import CRUD from "@/firebase/crud";
import store from "@/store/index";

const game = {
    namespaced: true,
    state:  {
        gameID: "",
        secondGameID: "",
        gameName: "",
        videoLink: "",
        result: {}
    },
    mutations: {
        setValue(state, [name, data]) {
            state[name] = data;
        },
        setGameData(state, data){
            state.result = data;
        }
    },
    actions: {
        sendGameData: async({commit}, payload) => {
            try {
                let gameID = payload[0];
                let videoLink = payload[1];
                // console.log("Payload game:\n " + "gameID: " + gameID + "\nvideoLink: " + videoLink);
                store.commit("game/setGameData", [gameID, videoLink]);
            } catch(err){
                // console.log(err);
            }
        }
    }
}

export default game;